exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#launcher {\n  left: 0px !important;\n}\n", ""]);

// exports
